import {Component, trigger, transition, style, animate, state} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'

import { PopupService } from './../../services/pop-up.service';

@Component({
    selector: 'pop-up-restricted-confirmation',
    templateUrl: 'restricted-confirmation-popup.component.html',
    animations: [
    trigger(
      'popupAnimation',
      [
        transition(
        ':enter', [
          style({opacity: 0}),
          animate('300ms', style({'opacity': 1}))
        ]
      ),
      transition(
        ':leave', [
          style({'opacity': 1}),
          animate('300ms', style({'opacity': 0}))
        ]
      )]
    )
  ],
})

export class RestrictedConfirmationPopupComponent {

    constructor(
        private _popupService: PopupService
    ) {

    }

    getPopupOption() {
        return this._popupService.popUpOptions;
    }

    getConfirmationFlag() {
        return this._popupService.getRestrictedConfirmationFlag();
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/popup/restricted-confirmation-popup.component.ts